var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "npnc" }, [
    _c(
      "h2",
      [
        _c("v-icon", { attrs: { color: "warning" } }, [_vm._v("warning")]),
        _vm._v(_vm._s(_vm.$t("Payments.Nuvei.NotCompleted.Headline")))
      ],
      1
    ),
    _vm._v(" "),
    _vm.infoMsg
      ? _c("div", { staticClass: "npnc-message" }, [
          _vm._v(_vm._s(_vm.infoMsg))
        ])
      : _c("div", { staticClass: "npnc-message" }, [
          _vm._v(_vm._s(_vm.$t("Payments.PNM.NotCompleted.Payment")))
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "goto__home" },
      [
        _c(
          "v-btn",
          {
            attrs: { large: "", color: "success" },
            on: {
              click: function($event) {
                return _vm.goToHomepage()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("Account.ChangePassword.GoToHomepage")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14251189", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14251189","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Nuvei/NuveiPaymentNotCompleted.vue
// module id = null
// module chunks = 